import React, { FC, useState } from 'react';
import styles from './styles.module.css';
import { formatDateTimeShortUsingTimezone } from 'Shared/utils';
import { SideDrawer, Button } from '@clearcover/atlas';
import { COLOR_MAP } from '../PolicyStatus';

import { useApi } from 'Shared/services/Api';
import { PolicyTermInfoType } from '@clearcover/core-app-types';
import { useParams } from 'react-router-dom';

// update to use core-app-type
export type PolicyTermSummaryList = Array<{
  id: string;
  termNumber: number;
  effectivePeriod: {
    startAt: string;
    endAt: string;
  };
  termInfo: PolicyTermInfoType;
}>;

type PropsType = {
  currentTermNumber: number;
  policyNumber: string;
  onTermChange: (id: number) => void;
  timeZone: string | undefined;
};

export const PolicyTermChooser: FC<PropsType> = ({
  policyNumber,
  currentTermNumber,
  onTermChange,
  timeZone,
}) => {
  const { id: policyId } = useParams<{
    id: string;
  }>();
  const [{ data: terms, loading, error }] = useApi<PolicyTermSummaryList>(
    `/policies/${policyId}/terms`,
    false
  );

  const [activeTerm, setActiveTerm] = useState<number>(currentTermNumber);

  return (
    <SideDrawer
      key="door"
      toggle={open => (
        <Button
          data-testid={'change-term-button'}
          className={styles.toggleButton}
          isSubmitting={false}
          disabled={loading || !!error}
          link
          size="sm"
          onClick={open}
        >
          Change Term
        </Button>
      )}
    >
      {close => (
        <div data-testid={'policy-term-chooser'} className={styles.container}>
          <div className={styles.header}>
            <h2>Select policy term</h2>
          </div>
          <div className={styles.section}>
            {(terms || []).map(term => {
              const isActiveState = activeTerm === term.termNumber;
              const classTerm = isActiveState ? styles.termActive : styles.term;
              return (
                <div
                  className={classTerm}
                  key={term.id}
                  data-testid={`term-${term.id}`}
                  onClick={() => setActiveTerm(term.termNumber)}
                >
                  <div>
                    {policyNumber}-{term.termNumber}
                  </div>

                  <div className={styles.date}>
                    {`${formatDateTimeShortUsingTimezone(
                      term.effectivePeriod.startAt,
                      timeZone
                    )}-${formatDateTimeShortUsingTimezone(
                      term.effectivePeriod.endAt,
                      timeZone
                    )}`}
                  </div>
                  <span
                    className={styles.termStatus}
                    style={{ color: COLOR_MAP[term.termInfo.termStatus] }}
                  >
                    {term.termInfo.termStatus}
                  </span>
                </div>
              );
            })}

            {terms.length <= 1 && (
              <div className={styles.empty}>
                NO ADDITIONAL POLICY TERMS AVAILABLE
              </div>
            )}
          </div>
          <div className={styles.buttonGroup}>
            <Button
              data-testid={'select-term-button'}
              variant="primary"
              block
              isSubmitting={false}
              disabled={activeTerm === currentTermNumber}
              onClick={() => {
                close();
                onTermChange(activeTerm);
              }}
            >
              Select This Term
            </Button>
            <Button
              variant="secondary"
              block
              className={styles.closeButton}
              onClick={close}
            >
              Cancel &#38; Close
            </Button>
          </div>
        </div>
      )}
    </SideDrawer>
  );
};
